import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
    selector: 'app-pb-institute-price-comparison',
    templateUrl: './pb-institute-price-comparison.component.html',
    styleUrls: ['./pb-institute-price-comparison.component.scss']
})
export class PbInstitutePriceComparisonComponent implements OnInit {

    @Input() module: any = {};
    @Input() id: any = 0;
    padding_top: any = '';
    padding_bottom: any = '';

    payMethod: string = 'once-off';
    institution: any = {};
    institutionLoaded: boolean = false;
    pricing: any = {};
    studyMethods: any = [];

    constructor(
        private api: ApiService,
        private cd: ChangeDetectorRef
    ) {

    }

    ngOnInit(): void {

        this.pricing = {
            'once-off': [],
            'monthly': []
        };

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

        this.fetchInstitution();
        this.fetchOfferedSubjects();

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding == 'SMALL') {
            return '10';
        } else if (padding == 'MEDIUM') {
            return '15';
        } else if (padding == 'LARGE') {
            return '30';
        } else if (padding == 'XLARGE') {
            return '60';
        }

    }

    /**
     * Fetch the institution before fetching the courses
     */
    async fetchInstitution() {

        await this.api.fetch_institution(this.id)
            .subscribe(res => {
                this.institution = res.data.item;
                this.institutionLoaded = true;
                this.cd.detectChanges();
            }, (err) => {

            });

    }

    /**
     * Fetch Offered Subjects to calculate pricing per study method
     */
    async fetchOfferedSubjects() {

        await this.api.fetch_offered_subject_products(this.id)
            .subscribe(res => {
                if (res.Result?.hasOwnProperty('SubjectLevels')) {

                    let levels = this.ensureArray(res.Result.SubjectLevels.SubjectLevel);

                    levels.forEach(level => {
                        let subjects = this.ensureArray(level.Subjects.Subject);

                        subjects.forEach(subject => {
                            let studyMethods = this.ensureArray(subject.StudyMethods.StudyMethod);

                            studyMethods.forEach(studyMethod => {
                                let index = this.studyMethods.findIndex(x => x.id == studyMethod.StudyMethodKey._text);
                                if (index !== -1) {
                                    if (Array.isArray(studyMethod.Products.Product)) {

                                    } else {
                                        let price = (studyMethod.Products.Product.UnitPrice.hasOwnProperty('_text') ? studyMethod.Products.Product.UnitPrice._text : 0);

                                        if (price) {
                                            this.studyMethods[index].pricing.push({
                                                'once-off': (studyMethod.Products.Product.UnitPrice.hasOwnProperty('_text') ? studyMethod.Products.Product.UnitPrice._text : 0),
                                                'monthly': (studyMethod.Products.Product.MonthlyUnitPrice.hasOwnProperty('_text') ? studyMethod.Products.Product.MonthlyUnitPrice._text : 0)
                                            });
                                        }
                                    }
                                } else {
                                    this.studyMethods.push({
                                        id: studyMethod.StudyMethodKey._text,
                                        title: studyMethod.StudyMethodName._text,
                                        slug: this.slugify(studyMethod.StudyMethodName._text),
                                        pricing: []
                                    });

                                    if (Array.isArray(studyMethod.Products.Product)) {

                                    } else {
                                        let price = (studyMethod.Products.Product.UnitPrice.hasOwnProperty('_text') ? studyMethod.Products.Product.UnitPrice._text : 0);

                                        if (price) {
                                            this.studyMethods[this.studyMethods.length - 1].pricing.push({
                                                'once-off': (studyMethod.Products.Product.UnitPrice.hasOwnProperty('_text') ? studyMethod.Products.Product.UnitPrice._text : 0),
                                                'monthly': (studyMethod.Products.Product.MonthlyUnitPrice.hasOwnProperty('_text') ? studyMethod.Products.Product.MonthlyUnitPrice._text : 0)
                                            });
                                        }
                                    }
                                }

                            });
                        });
                    });
                }

                this.studyMethods.forEach(studyMethod => {
                    studyMethod.pricing.sort((a, b) => (a['once-off'] > b['once-off']) ? 1 : -1);
                });

                this.cd.detectChanges();
            }, (err) => {

            });

    }

    togglePricing(period: string) {

        if (period == 'once-off') {
            this.studyMethods.forEach(studyMethod => {
                studyMethod.pricing.sort((a, b) => (a['once-off'] > b['once-off']) ? 1 : -1);
            });
        } else if (period == 'monthly') {
            this.studyMethods.forEach(studyMethod => {
                studyMethod.pricing.sort((a, b) => (a['monthly'] > b['monthly']) ? 1 : -1);
            });
        }

    }

    /**
     * Slugify a string. Used with the study method name
     * @param str 
     * @returns 
     */
    slugify(str) {
        str = this.replaceAccents(str);
        str = this.removeNonWord(str);
        str = str.replace(/ +/g, '-') //replace spaces with delimeter
            .toLowerCase();

        return str;
    }

    /**
     * Remove non-word chars.
     */
    removeNonWord(str) {
        return str.replace(/[^0-9a-zA-Z\xC0-\xFF \-]/g, "");
    }

    /**
     * Replaces all accented chars with regular ones
     */
    replaceAccents(str) {
        if (str.search(/[\xC0-\xFF]/g) > -1) {
            str = str
                .replace(/[\xC0-\xC5]/g, "A")
                .replace(/[\xC6]/g, "AE")
                .replace(/[\xC7]/g, "C")
                .replace(/[\xC8-\xCB]/g, "E")
                .replace(/[\xCC-\xCF]/g, "I")
                .replace(/[\xD0]/g, "D")
                .replace(/[\xD1]/g, "N")
                .replace(/[\xD2-\xD6\xD8]/g, "O")
                .replace(/[\xD9-\xDC]/g, "U")
                .replace(/[\xDD]/g, "Y")
                .replace(/[\xDE]/g, "P")
                .replace(/[\xE0-\xE5]/g, "a")
                .replace(/[\xE6]/g, "ae")
                .replace(/[\xE7]/g, "c")
                .replace(/[\xE8-\xEB]/g, "e")
                .replace(/[\xEC-\xEF]/g, "i")
                .replace(/[\xF1]/g, "n")
                .replace(/[\xF2-\xF6\xF8]/g, "o")
                .replace(/[\xF9-\xFC]/g, "u")
                .replace(/[\xFE]/g, "p")
                .replace(/[\xFD\xFF]/g, "y");
        }

        return str;
    }

    /**
     * Changes catalyst response to always be an array
     * @param possibleArray 
     * @returns 
     */
    ensureArray(possibleArray) {
        if (possibleArray) {
            if (Array.isArray(possibleArray)) {
                return possibleArray;
            } else {
                return [possibleArray];
            }
        } else {
            return [];
        }
    }

}
